import { I18nManager, Platform } from 'react-native';

import type { Locale } from './index';

export function isRTLLocale(locale: Locale): boolean {
  return locale === 'ar';
}

/**
 * Apply layout direction for the locale.
 * Returns true when a full app reload is required for the change to take
 * effect (native only - RN bakes direction in at startup).
 */
export function applyDirection(locale: Locale): boolean {
  const rtl = isRTLLocale(locale);

  if (Platform.OS === 'web') {
    if (typeof document !== 'undefined') {
      document.documentElement.dir = rtl ? 'rtl' : 'ltr';
      document.documentElement.lang = locale;
    }
    return false;
  }

  I18nManager.allowRTL(rtl);
  if (I18nManager.isRTL !== rtl) {
    I18nManager.forceRTL(rtl);
    return true;
  }
  return false;
}

/** Best-effort app reload after a direction change; false when unavailable. */
export async function tryReload(): Promise<boolean> {
  try {
    const Updates = await import('expo-updates');
    await Updates.reloadAsync();
    return true;
  } catch {
    // Dev client / Expo Go may refuse - the caller shows a "restart app" hint.
    return false;
  }
}
